module.exports = __webpack_public_path__ + "static/media/check-white-small.17c17b25.svg";